var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "modal-title" }, [_vm._v(" BOARD ")]),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_board.title.$error } },
        [
          _c("label", [_vm._v(" Board Title ")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { "max-length": 255, placeholder: "Board Title" },
            model: {
              value: _vm.$v.data_board.title.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_board.title, "$model", $$v)
              },
              expression: "$v.data_board.title.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_board.board.$error } },
        [
          _c("label", [_vm._v(" Select Board ")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              options: _vm.list_board,
              label: "name",
              "value-format": "object",
              placeholder: "Choose Board"
            },
            model: {
              value: _vm.$v.data_board.board.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_board.board, "$model", $$v)
              },
              expression: "$v.data_board.board.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_board.field.$error } },
        [
          _c("label", [_vm._v(" Select Field ")]),
          _vm._v(" "),
          _c("j-multi-select", {
            attrs: {
              options: _vm.list_field,
              label: "name",
              "value-format": "object",
              placeholder: "Select Field"
            },
            model: {
              value: _vm.$v.data_board.field.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_board.field, "$model", $$v)
              },
              expression: "$v.data_board.field.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "float-to-right" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn gray m__r--5",
                    on: { click: _vm.closeBoard }
                  },
                  [_vm._v("\n          Close\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  { staticClass: "btn blue", on: { click: _vm.saveBoard } },
                  [_vm._v("\n          Save\n        ")]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalCreateBoard",
          staticClass: "mod-form",
          attrs: { centered: "" }
        },
        [
          _c("label", [_vm._v("CREATE BOARD")]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.data_create_board.name.$error } },
            [
              _c("label", [_vm._v(" Board Name ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: { "max-length": 255, placeholder: "Board Name" },
                model: {
                  value: _vm.$v.data_create_board.name.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.data_create_board.name, "$model", $$v)
                  },
                  expression: "$v.data_create_board.name.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              class: {
                "error-input": _vm.$v.data_create_board.description.$error
              }
            },
            [
              _c("label", [_vm._v(" Description ")]),
              _vm._v(" "),
              _c("j-textarea", {
                attrs: { "max-length": 300, placeholder: "Description" },
                model: {
                  value: _vm.$v.data_create_board.description.$model,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.$v.data_create_board.description,
                      "$model",
                      $$v
                    )
                  },
                  expression: "$v.data_create_board.description.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue m__r--5",
                        on: { click: _vm.createBoard }
                      },
                      [_vm._v("\n            Finish\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray",
                        on: { click: _vm.closeCreateBoard }
                      },
                      [_vm._v("\n            Close\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-93cd701e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93cd701e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/pages-component/jBoardSetup.vue
// module id = null
// module chunks = 